import React, { useContext, useEffect, useState } from 'react'
import 'src/views/container/cms/content.scss'
import '../../../scss/style.scss'
import {
  // convertDuration,
  // formatBytes,
  getThumbnail,
  // getVideoThumbnail,
  isEmpty,
} from '../../../views/utils/helper'
import moment from 'moment'
import { GlobalContext } from 'src/views/context/GlobalState'
import ReactDragListView from 'react-drag-listview/lib/index.js'
import PlusIcon from '../../../assets/plus-icon.svg'
import CustomPreviewListCard from 'src/views/container/AssetManager/customPreviewListCard'
import { isArray } from 'lodash'
import useAxios from 'axios-hooks'
import { CONTENT_FILTER_XAVIER } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'

const DefaultSwimlanePreview = ({
  title = 'Swimlane',
  filterData,
  setContentData,
  goBackToSelection,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)
  const [previewContentData, setPreviewContentData] = useState([])

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    contentListCall({
      data: {
        filters: filterData,
        page: 1,
        order_by: 'modified_date',
        page_size: filterData?.content_ids?.length,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  useEffect(() => {
    if (contentList && contentList.success) {
      contentList?.data.sort((a, b) => {
        let sortingArr = filterData?.content_ids
        return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
      })

      setPreviewContentData(contentList.data)
    }
  }, [contentList])

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      const data = [...previewContentData]
      const item = data.splice(fromIndex, 1)[0]
      data.splice(toIndex, 0, item)
      setPreviewContentData([...data])
      setContentData([...data])
    },
    nodeSelector: 'li',
    handleSelector: '',
  }

  const handleRemoveContent = (id) => {
    const tempData = previewContentData.filter((item) => item?.content_id !== id)
    setPreviewContentData([...tempData])
    setContentData([...tempData])
  }
  return (
    <div style={{ marginTop: '5px' }}>
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <h5
            style={{
              color: '#191818',
              fontSize: '30px',
              fontWeight: '700',
              marginBlockEnd: '0',
            }}
          >
            {title.toUpperCase()} PREVIEW
          </h5>
        </div>
      </div>
      {/* // filter and list/grid toggle div */}
      <div
        className="d-flex justify-content-center"
        style={{
          padding: '1.42vw 0vw 0',
          margin: '1.2vh auto 3vh',
          width: '100%',
          // outline: '2px solid red',
          position: 'relative',
        }}
      >
        <h6 style={{ marginRight: 'auto', fontSize: '14px' }}>
          {previewContentData.length} Contents Added to {title}
        </h6>
        <h6 style={{ marginLeft: 'auto', fontSize: '14px' }}>*Drag to Re-arrange</h6>
      </div>
      {/* // asset manager lookalike content manager(content listing) */}
      <div className="position-relative overflow-hidden">
        <div
          className="custom-scrollbar-vertical"
          style={{
            height: '50vh',
            overflowY: 'auto',
            padding: '30px 2px 10px 2px',
            overflowX: 'hidden',
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute rounded-2"
            style={{
              fontSize: 'max(0.63vw,10px)',
              gap: '0 .6%',
              padding: '2px .5vw',
              zIndex: '10',
              position: 'fixed',
              top: '0',
            }}
          >
            <div style={{ width: '2%', height: '100%' }}></div>
            <div style={{ width: '9%', height: '100%' }}></div>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{ width: '85%', background: 'none' }}
            >
              <p style={{ marginBlockEnd: '0', width: '20%', background: 'none' }}>Title</p>
              <p style={{ marginBlockEnd: '0', width: '10%', background: 'none' }}>Duration</p>
              <p style={{ marginBlockEnd: '0', width: '10%', background: 'none' }}>Publish Date</p>
              <p style={{ marginBlockEnd: '0', width: '10%', background: 'none' }}>Content Type</p>
              <p
                style={{
                  marginBlockEnd: '0',
                  width: '20%',
                  background: 'none',
                }}
              >
                Category
              </p>
              <div style={{ width: '2%' }}></div>
            </div>
          </div>
          <ReactDragListView {...dragProps}>
            <ul className="list-unstyled">
              {!isEmpty(previewContentData)
                ? previewContentData.map((info, index) => (
                    <li key={index}>
                      <CustomPreviewListCard
                        cardStyle={{ marginBottom: '.8vw', aspectRatio: '1181/71' }}
                        cardImage={getThumbnail(
                          userSessionObj.session_data.cf_domain_name,
                          info?.thumbnail,
                        )}
                        playIconForVideo={true}
                        fileName={info?.title}
                        rightText={moment(info?.publish_time).format('DD MMM YYYY')}
                        // if it's a live stream duration will be the streaming duration(differece of live_expiry_time and publish_time)
                        duration={'N/A'}
                        contentType={info?.video_type}
                        // category={info?.category?.name} // now on categories will go instead of single category
                        categories={
                          isArray(info?.category)
                            ? info?.category.map((info) => info.name)
                            : [info?.category.name]
                        } // categories
                        actionButtonAction={() => handleRemoveContent(info.content_id)}
                      />
                    </li>
                  ))
                : !contentListLoading && <h5 className="no-data-text">No Content Found!</h5>}
            </ul>
          </ReactDragListView>
          <div
            className="cursor-pointer rounded w-full d-flex flex-col justify-content-center align-items-center p-3 on-card-hover"
            style={{
              borderRadius: '10px',
              background: '#ececec',
            }}
            onClick={goBackToSelection}
          >
            <div
              className="h-[24px] w-[24px] rounded-full flex justify-center items-center"
              style={{ boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, .5)', background: '#000' }}
              role="button"
            >
              <img src={PlusIcon} alt="trashicon" />
            </div>
            <p className=" mb-0 fw-semibold">Add/Edit more Content</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DefaultSwimlanePreview
